import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/modal";
import api from "../../../services/api";
import useStore from "../../../services/store";

export default function CreateProject() {
  const [values, setValues] = useState({ name: "", description: "" });

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { organisation } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      values.status = "active";
      // Set organisation if one is selected (and not "ALL")
      if (organisation && organisation._id !== "ALL") {
        values.organisation_id = organisation._id;
        values.organisation_name = organisation.name;
      }
      const res = await api.post("/project", values);
      if (!res.ok) throw res;
      toast.success("Project Created Successfully!");
      setOpen(false);
      navigate(`/project/${res.data._id}`);
    } catch (e) {
      console.log(e);
      toast.error("Error creating project", e.code);
    }
    setLoading(false);
  };

  return (
    <>
      <button className="btn blue-btn hover:bg-blue-600 transition-colors duration-200" onClick={() => setOpen(true)}>
        Create new project
      </button>
      <Modal isOpen={open} className="max-w-3xl w-full p-6 rounded-lg" onClose={() => setOpen(false)}>
        <div className="p-8 bg-white rounded-lg shadow-sm">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">Project Name</label>
              <input
                className="projectsInput block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                name="name"
                value={values.name}
                onChange={(e) => setValues({ ...values, name: e.target.value })}
                placeholder="Enter project name"
                required
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">Description</label>
              <textarea
                className="projectsInput block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 min-h-[120px] resize-y"
                name="description"
                value={values.description}
                onChange={(e) => setValues({ ...values, description: e.target.value })}
                placeholder="Describe your project in detail..."
                rows={4}
                required
              />
            </div>

            <div className="flex justify-end pt-4">
              <button
                type="submit"
                className="btn blue-btn hover:bg-blue-600 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={loading || !values.name}>
                {loading ? "Creating..." : "Create Project"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};
